import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import ManageDatesBudget from './budgetdates';
import VehiclesMaintenance from './vehiclesMaintenance';
import VehiclesModel from './vehiclesModel';
import ManageColors from './manageColors';
import ManageColorsFormAdd from './manageColorsForm';
import ClientManagement from './clientManagement';
import AdvisorManagement from './advisorManagement';
import ExemptionManagement from './exemptionManagement';
import VehiclesPriceColorLoad from './vehiclesPriceColorLoad';

export const budgetVehiclesRoutes = [
  {
    'component': <ManageDatesBudget />,
    'path': paths.ManageDatesBudget,
  },
  {
    'component': <VehiclesMaintenance />,
    'path': paths.VehiclesMaintenance,
  },
  {
    'component': <VehiclesModel />,
    'path': paths.VehiclesModels,
  },
  {
    'component': <ManageColors />,
    'path': paths.ManageColors,
  },
  {
    'component': <ManageColorsFormAdd />,
    'path': paths.ManageColorsFormAdd,
  },
  {
    'component': <ClientManagement />,
    'path': paths.ClientManagement,
  },
  {
    'component': <AdvisorManagement />,
    'path': paths.AdvisorManagement,
  },
  {
    'component': <ExemptionManagement />,
    'path': paths.ExemptionPercentagesManagement,
  },
  {
    'component': <VehiclesPriceColorLoad />,
    'path': paths.VehiclesPriceColorLoad,
  },
];
